import { render, staticRenderFns } from "./Enquiry.vue?vue&type=template&id=05ecb45b"
import script from "./Enquiry.vue?vue&type=script&lang=js"
export * from "./Enquiry.vue?vue&type=script&lang=js"
import style0 from "./Enquiry.vue?vue&type=style&index=0&id=05ecb45b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports